import * as Yup from 'yup';

import { Formik, Form } from 'formik';
import ValidationCheckbox from '../input/ValidationCheckbox';
import ValidationInput from 'src/components/input/ValidationTextInput';
import { Button } from 'react-bootstrap';

const saleSchema = Yup.object().shape({
  price: Yup.number().required().positive(),
  date: Yup.date().required(),
  active: Yup.boolean(),
});

const SaleForm = ({ initialValues, save }) => (
  <div style={{ maxWidth: 500, margin: '0 auto' }}>
    <Formik onSubmit={save} initialValues={initialValues} validationSchema={saleSchema}>
      <Form>
        <ValidationInput name="price" type="number" />
        <ValidationInput name="date" type="date" />
        <ValidationCheckbox name="active" label="Active" />
        <Button variant="success" type="submit" className="px-4" data-cy="data-submit">
          Save
        </Button>
      </Form>
    </Formik>
  </div>
);

export default SaleForm;
